import { createContext } from 'react';
import type { PopupActions } from 'reactjs-popup/dist/types';

export const PopupMenuContext = createContext<
  (() => { actions: PopupActions | null; selectedIds?: (string | number)[] }) | undefined
>(undefined);
